module.exports = __webpack_public_path__ + "static/media/banner-right.f174837b.png";